// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconApple = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M12.297 5.538c1.11 0 2.5-.732 3.328-1.708.75-.885 1.297-2.121 1.297-3.357 0-.168-.016-.336-.047-.473-1.234.046-2.719.809-3.61 1.83-.703.779-1.343 2-1.343 3.25 0 .184.031.367.047.428.078.015.203.03.328.03zM8.39 24c1.515 0 2.187-.992 4.078-.992 1.922 0 2.344.962 4.031.962 1.656 0 2.766-1.496 3.813-2.96 1.171-1.679 1.656-3.327 1.687-3.403-.11-.03-3.281-1.297-3.281-4.852 0-3.082 2.5-4.47 2.64-4.577-1.656-2.32-4.172-2.38-4.859-2.38-1.86 0-3.375 1.098-4.328 1.098-1.031 0-2.39-1.037-4-1.037C5.109 5.859 2 8.33 2 12.999c0 2.9 1.156 5.966 2.578 7.95C5.797 22.627 6.86 24 8.391 24z"
      fill="#000"
    />
  );
export default SvgIconApple;
